import React, { useState } from 'react';
import { Card, Button, Tag, Row, Col, Popover, Checkbox, Popconfirm } from 'antd';
import { CloseOutlined, DeleteOutlined, EditOutlined, FilterFilled, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import BreadcrumbComponent from '../../../components/Breadcrumb';
import { IBreadcrumbItem } from '../../../models/breadcrumb';
import { useTranslation } from 'react-i18next';
import './styles.css';
import { IDropdown } from '../../../models/input';
import { useNavigate } from 'react-router-dom';
import editIndicator from '../../../assets/images/edit.svg';
import deleteIndicator from '../../../assets/images/delete.svg';


interface IndicatorsMappingProps {
    ministries: any[];
    handleMapMinistry?: (value?: any) => void;
    handleDeleteMinistry?: (ministryId: any) => void;
    associatedIndicators: IDropdown[];
    filterSelectedIndicators: number[];
    filterOnChange: (checkedValued: number[]) => void;
    isAllSelected: boolean;
}

const IndicatorsMapping: React.FC<IndicatorsMappingProps> = (props) => {
    const { t } = useTranslation();
    const [expandedMinistries, setExpandedMinistries] = useState<number[]>([]);
    const navigate = useNavigate();

    const breadcrumbItems: Array<IBreadcrumbItem> = [
        { title: t('home'), path: '/home' },
        { title: t('mapping-indicator.ministries-departments') },
    ];

    // Handle the toggle of 'Show More' and 'Show Less'
    const toggleExpandMinistry = (ministryId: number) => {
        if (expandedMinistries.includes(ministryId)) {
            setExpandedMinistries(expandedMinistries.filter(id => id !== ministryId));
        } else {
            setExpandedMinistries([...expandedMinistries, ministryId]);
        }
    };

    return (
        <Row className='mainTextArea' style={{ width: '100%' }} justify="space-between"  >
            <Col xs={24} sm={24} md={24} lg={24} xl={24} >
                <Row gutter={[16, 16]} style={{ borderBottom: '1px solid #CCC', marginBottom: '10px', paddingBottom: '10px' }}>
                    <Col xs={24} sm={24} md={17} lg={17} xl={17} >
                        <h4>{t('mapping-indicator.ministries-departments')}</h4>
                        <BreadcrumbComponent items={breadcrumbItems} separator='>' />
                    </Col>
                    <Col xs={24} sm={24} md={7} lg={7} xl={7} className='actionButHolder' style={{ padding: '8px 0 0' }}>
                        <div style={{ paddingBottom: '10px 0' }}>
                            <Popover
                                placement='bottom'
                                trigger={'click'}
                                content={
                                    <>
                                        <div className='filterSelected'>
                                            <Checkbox
                                                checked={props.isAllSelected}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    props.filterOnChange(checked ? props.associatedIndicators.map(ind => ind.id) : []);
                                                }}>
                                                {t('select-all')}
                                            </Checkbox>
                                            <Checkbox.Group
                                                style={{ display: 'block' }}
                                                value={props.filterSelectedIndicators}
                                                onChange={(checkedValues) => { props.filterOnChange(checkedValues) }}>
                                                {props?.associatedIndicators.map((indicator) => (
                                                    <Checkbox key={indicator.id} value={indicator.id}>
                                                        {indicator.name}
                                                    </Checkbox>
                                                ))}
                                            </Checkbox.Group>
                                        </div>
                                        <div className='filterclearAll'>
                                            <Button type='link' onClick={() => { props.filterOnChange([]) }}>
                                                <CloseOutlined /><span style={{ padding: '0 10px' }}>{t('clear-all')}</span>
                                            </Button>
                                        </div>
                                    </>
                                }
                                overlayInnerStyle={{ height: '413px', overflowY: 'auto' }}
                            >
                                <Button disabled={props?.associatedIndicators?.length ? false : true} type="primary"><FilterFilled /> {t('btn.filter')}</Button>
                            </Popover>
                            <Button onClick={() => navigate('/setup/indicators-mapping/add')} type="primary">{t('btn.map.indicator')}</Button>
                        </div>
                    </Col>
                </Row>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='cardScrollBar'>
                {props?.ministries && props?.ministries?.length &&
                    props.ministries.map((ministry: any) => {
                        const isExpanded = expandedMinistries.includes(ministry.id);
                        const displayedIndicators = isExpanded ? ministry.indicators : ministry.indicators.slice(0, 4);

                        return (
                            <>
                            <div >
                            <Card
                                className='ministriesCard'
                                key={ministry.id}
                                title={ministry.name}
                                extra={
                                    <>
                                        {ministry?.indicators?.length ?
                                           <img src={editIndicator} onClick={() => navigate(`/setup/indicators-mapping/edit/${ministry.id}`)}  style={{ margin: 10, cursor:'pointer' }}/> 
                                            : 
                                            <PlusOutlined onClick={() => navigate(`/setup/indicators-mapping/edit/${ministry.id}`)} />
                                        }

                                        <Popconfirm
                                            title={t('confirmation')}
                                            description={t('mapping.delete.msg')}
                                            okText={t('yes')}
                                            cancelText={t('no')}
                                            onConfirm={() => props?.handleDeleteMinistry?.(ministry.id)}
                                        >
                                            <img src={deleteIndicator}  style={{ margin: 10, cursor:'pointer' }}/>  
                                        </Popconfirm>
                                    </>
                                }
                                style={{ margin: '10px 10px' }}>
                                <Row gutter={[16, 16]}>
                                    {displayedIndicators?.map((indicator: any) => (
                                        <Col key={indicator.id}>
                                            <Tag className={props.filterSelectedIndicators.includes(indicator.id) ? 'tag_highlite ' : ''}>{indicator.name}</Tag>
                                        </Col>
                                    ))}
                                </Row>

                                {/* Show More / Show Less button */}
                                {ministry.indicators.length > 4 &&
                                    <Button type="link" onClick={() => toggleExpandMinistry(ministry.id)} className='showmore'>
                                        {isExpanded ? (<><MinusOutlined /> {t('btn.show-less')}</>) : (<><PlusOutlined /> {t('btn.show-more')}</>)}
                                    </Button>
                                }
                            </Card>
                            </div>
                            </>
                        );
                    })}
            </Col>
        </Row>
    );


}





export default IndicatorsMapping;
